/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CouponState {
  Issued = "issued",
  Voided = "voided",
  Used = "used",
}

export function instanceOfCouponState(value: any): boolean {
  for (const key in CouponState) {
    if (Object.prototype.hasOwnProperty.call(CouponState, key)) {
      if (CouponState[key as keyof typeof CouponState] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CouponStateFromJSON(json: any): CouponState {
  return CouponStateFromJSONTyped(json, false);
}

export function CouponStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CouponState {
  return json as CouponState;
}

export function CouponStateToJSON(value?: CouponState | null): any {
  return value as any;
}

export function CouponStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CouponState {
  return value as CouponState;
}
